export enum ApplicationQuestionTypeEnum {
  BeneficiariesNumber = 1,
  Activity = 2,
  TransactionsPurpose = 3,
  FundsSource = 4,
  IncommingGeography = 5,
  OutgoingGeography = 6,
  ActivityDetails = 7,
  IncomingDescription = 8,
  OutgoingDescription = 9,
  MainPartners = 10,
  PaymentsType = 11,
  BanksList = 12,
  Employees = 13,
  TaxResidence = 14,
  RepresentsOwnInterests = 15,
  RepresentsCompanyInterests = 16,
  CorporateLawForm = 17,
  PrivateSector = 18,
  EntityBranches = 19,
  CorporateOwners = 20,
  WealthSource = 21,

  // --- FINTWIN KYC additive question types (22-57). Added alongside legacy
  // 1-21; legacy members above MUST NOT change. New question types come from
  // backend MR ib!2338. Not all are used by the NP-T2 builder yet; the enum is
  // kept complete for later questionnaire phases. ---
  // 22 residence: backend `ResidenceApplication` (single ISO3, CountriesApplication).
  Residence = 22,
  Citizenship = 23,
  ExpectedMonthlyVolume = 24,
  Occupation = 25,
  ActivityDetail = 26,
  UsPerson = 27,
  CountryOfBirth = 28,
  TransactionPurpose = 29,
  SourceOfFunds = 30,
  SourceOfWealth = 31,
  Services = 32,
  Pep = 33,
  EeaConfirmation = 34,
  Declarations = 35,
  // --- NP-Business (Tier 3) question types (36-43). Verified against the
  // NP-Business type-id list; additive alongside the NP-Personal members. ---
  BusinessRole = 36,
  BusinessRegistration = 37,
  IndustrySector = 38,
  OnlinePresence = 39,
  AnnualTurnover = 40,
  Licence = 41,
  PurposeBusiness = 42,
  SourceOfFundsBusiness = 43,
  // --- Legal Person / Corporate (LP, Tier 2 / Tier 3) question types (44-57).
  // Additive alongside the NP members; ids + option lists from the LP build
  // spec (FINTWIN_KYC_LP_Spec) and the §3 type catalog. Legacy NP types are
  // reused where the question is identical (38 industry, 39 online presence,
  // 41 licence, 2 business description, 32 services, 26 activity detail,
  // 8/9 in/out descriptions, 5/6 geography, 14 tax residence, 34 EEA,
  // 35 declarations). ---
  EntityType = 44, // A2 entity type (single)
  CountryOfIncorporation = 45, // A3 country of incorporation (iso single)
  PrincipalPlaceOfBusiness = 46, // A5 principal place of business (iso 1+)
  FatcaClassification = 47, // A7 FATCA classification (single)
  Giin = 48, // A7b GIIN gate (is_financial_institution, giin)
  CrsClassification = 49, // A8 CRS classification (single)
  OwnershipComplexity = 50, // C1 ownership structure (single)
  BearerShares = 51, // C2 bearer shares / nominees (bool gate)
  PurposeLp = 52, // E1 purpose of the relationship (multi + Other)
  SourceOfWealthEntity = 53, // F1 source of the company's wealth (multi + Other)
  ExpectedMonthlyVolumeLp = 54, // E3 expected monthly volume (single)
  AnnualTurnoverLp = 55, // F3 annual turnover (single)
  SanctionsDeclaration = 56, // G2 sanctions & integrity (bool gate + details)
  Signatory = 57, // G4 signatory block (full_name, capacity, date)
}
